import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
import { CTA_LABEL, site } from '../data/site';
export function FinalCTASection() {
  return <section className="relative overflow-hidden bg-brand-blue px-4 py-20 text-center text-white md:py-24" data-id="element-70" data-mp="3n4w95zmccbix">
      <img src={site.heroImage} alt="" aria-hidden="true" loading="lazy" className="pointer-events-none absolute -bottom-10 left-1/2 w-[820px] max-w-none -translate-x-1/2 opacity-[0.09]" data-id="element-71" data-mp="vv5q6evisqi" />
      <Reveal className="relative mx-auto max-w-3xl" data-id="element-72" data-mp="34dmznqcklmrc">
        <h2 className="text-3xl font-black leading-[1.1] md:text-[2.85rem]" data-id="element-73" data-mp="39bokafpn9u4x">
          Ready to Walk Into Every PE Class Prepared?
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-white/75" data-id="element-74" data-mp="3e3gagp4w1xuj">
          Stop searching, improvising, and rebuilding every lesson from scratch. Get the complete Elementary and
          Secondary PE system and start planning with confidence.
        </p>
        <div className="mx-auto mt-8 flex w-full max-w-sm flex-col items-center" data-id="element-75" data-mp="26vk5bjtizy0z">
          <CTAButton className="w-full py-4 text-base md:text-lg" data-id="element-76" data-mp="21vxwrnon75yi">{CTA_LABEL}</CTAButton>
          <p className="mt-3 text-xs font-semibold text-white/70" data-id="element-77" data-mp="21yabzt30n27v">
            10 volumes • 5 bonuses • Instant access • One-time payment
          </p>
        </div>
      </Reveal>
    </section>;
}